module.exports = __webpack_public_path__ + "img/icon-1.2cd77fdc.png";